import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environments';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface CreateOrderResponse {
    paypalOrderId: string;
}

export interface CaptureOrderResponse {
    success: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class PaypalService {
    constructor(private http: HttpClient) {}

    createOrder(orderId: string): Observable<CreateOrderResponse> {
        return this.http.post<CreateOrderResponse>(
            `${environment.apiUrl}/paypal/create-order?orderId=${orderId}`,
            {}
        );
    }

    captureOrder(orderId: string, paypalOrderId: string): Observable<CaptureOrderResponse> {
        return this.http.post<CaptureOrderResponse>(
            `${environment.apiUrl}/paypal/capture-order?orderId=${orderId}&paypalOrderId=${paypalOrderId}`,
            {}
        );
    }
}
